function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/Login/index.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import merge from "lodash.merge";
import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { AccountTypes } from "../Account";
import { LoginContainer, LoginHeader, LoginSection, LoginSubHeader } from "./styles";
var noop = function noop() {
  return null;
};
var DefaultCopyConfig = {
  widgetHeader: " ",
  header: "",
  subHeaderMessage: "",
  usernamePlaceholder: "Email",
  passwordPlaceholder: "Password",
  submitButton: "Login",
  helpLink: "Need Help Logging in?",
  registerLabel: "Don't have an account?",
  registerLink: "Sign up",
  requiredCopy: "required",
  errorMessage: "Authentication Error. Please check email and/or password and try again.",
  successHeader: "Login Success!",
  successSubHeader: ""
};
var DefaultFeatures = {
  registration: false,
  rememberMe: false
};
var DefaultHelpLinks = {
  help: "/help",
  forgotPassword: "/forgot-password"
};
var DefaultTracking = {
  loginSuccessProps: {},
  loginFailureProps: {},
  loginSubmitProps: {}
};
var Login = function Login(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? "#fff" : _ref$backgroundColor,
    containerProps = _ref.containerProps,
    _ref$containerWidth = _ref.containerWidth,
    containerWidth = _ref$containerWidth === void 0 ? "50%" : _ref$containerWidth,
    copyConfig = _ref.copyConfig,
    _ref$disableUsernameI = _ref.disableUsernameInput,
    disableUsernameInput = _ref$disableUsernameI === void 0 ? false : _ref$disableUsernameI,
    _ref$email = _ref.email,
    email = _ref$email === void 0 ? "" : _ref$email,
    features = _ref.features,
    helpLinks = _ref.helpLinks,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? "en-US" : _ref$locale,
    _ref$onClickRegistrat = _ref.onClickRegistrationLink,
    onClickRegistrationLink = _ref$onClickRegistrat === void 0 ? noop : _ref$onClickRegistrat,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? noop : _ref$onError,
    _ref$onFailure = _ref.onFailure,
    onFailure = _ref$onFailure === void 0 ? noop : _ref$onFailure,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? noop : _ref$onSuccess,
    _ref$setAccountType = _ref.setAccountType,
    setAccountType = _ref$setAccountType === void 0 ? noop : _ref$setAccountType,
    tracking = _ref.tracking;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    OktaSignInWidget = _useState2[0],
    setOktaSignInWidget = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoggedIn = _useState4[0],
    setIsLoggedIn = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    signIn = _useState6[0],
    setSignIn = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    oktaLibraryError = _useState8[0],
    setOktaLibraryError = _useState8[1]; // if no okta on window, return null
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    widgetRendered = _useState10[0],
    setWidgetRendered = _useState10[1];
  var _useMemo = useMemo(function () {
      return merge(DefaultCopyConfig, copyConfig);
    }, [copyConfig]),
    widgetHeader = _useMemo.widgetHeader,
    header = _useMemo.header,
    subHeaderMessage = _useMemo.subHeaderMessage,
    usernamePlaceholder = _useMemo.usernamePlaceholder,
    passwordPlaceholder = _useMemo.passwordPlaceholder,
    submitButton = _useMemo.submitButton,
    helpLink = _useMemo.helpLink,
    registerLabel = _useMemo.registerLabel,
    registerLink = _useMemo.registerLink,
    requiredCopy = _useMemo.requiredCopy,
    errorMessage = _useMemo.errorMessage,
    successHeader = _useMemo.successHeader,
    successSubHeader = _useMemo.successSubHeader;
  var combinedFeatures = useMemo(function () {
    return merge(DefaultFeatures, features);
  }, [features]);
  var combinedHelpLinks = useMemo(function () {
    return merge(DefaultHelpLinks, helpLinks);
  }, [helpLinks]);
  var _useMemo2 = useMemo(function () {
      return merge(DefaultTracking, tracking);
    }, [tracking]),
    loginSuccessProps = _useMemo2.loginSuccessProps,
    loginFailureProps = _useMemo2.loginFailureProps,
    loginSubmitProps = _useMemo2.loginSubmitProps;

  // Due to library only being client side, we need to lazy load it so any SSR doesn't throw errors
  useEffect(function () {
    function loadOkta() {
      return _loadOkta.apply(this, arguments);
    }
    function _loadOkta() {
      _loadOkta = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var OktaSignInWidget;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return import( /* webpackMode: "eager" */
                "@okta/okta-signin-widget");
              case 2:
                OktaSignInWidget = _context.sent;
                setOktaSignInWidget(OktaSignInWidget);
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadOkta.apply(this, arguments);
    }
    loadOkta();
  }, []);
  useEffect(function () {
    if (!window.mlbOkta) {
      var message = "Error! There was no Okta library found on the window. Make sure you are consuming the package in a valid MLB section";
      setOktaLibraryError(true);
      onError(new Error(message));
    }
    if (OktaSignInWidget) {
      var getAuthConfig = window.mlbOkta.getAuthConfig;
      var config = getAuthConfig();
      var oktaSignInConfig = {
        baseUrl: config.okta,
        clientId: config.clientId,
        redirectUri: "".concat(location.origin, "/login"),
        authParams: {
          issuer: config.issuer
        },
        registration: {
          click: function click() {
            onClickRegistrationLink();
            setAccountType(AccountTypes.REGISTER);
          }
        },
        username: email,
        features: combinedFeatures,
        helpLinks: combinedHelpLinks,
        i18n: {
          en: {
            "primaryauth.title": widgetHeader,
            "primaryauth.username.placeholder": "".concat(usernamePlaceholder, " *"),
            "primaryauth.username.tooltip": usernamePlaceholder,
            "primaryauth.password.placeholder": "".concat(passwordPlaceholder, " *"),
            "primaryauth.password.tooltip": passwordPlaceholder,
            "primaryauth.submit": submitButton,
            needhelp: helpLink,
            "errors.E0000004": errorMessage,
            "registration.signup.label": registerLabel,
            "registration.signup.text": registerLink
          }
        }
      };
      var oktaSignIn = OktaSignInWidget.default;
      setSignIn(new oktaSignIn(oktaSignInConfig));
    }
  }, [OktaSignInWidget]);
  useEffect(function () {
    if (signIn) {
      try {
        signIn.renderEl({
          el: document.getElementById("OKTASignin")
        }, success, onError);
        signIn.on("afterError", function (_, error) {
          if (window.trackAsync && loginFailureProps) {
            window.trackAsync(loginFailureProps);
          }
          onError(error);
        });
        signIn.on("afterRender", function () {
          setWidgetRendered(true);
          modifyInputFields();
          var submitButton = document.getElementById("okta-signin-submit");
          if (submitButton && loginSubmitProps) {
            submitButton.addEventListener("click", function () {
              if (window.trackAsync && loginSubmitProps) {
                window.trackAsync(loginSubmitProps);
              }
            });
          }
        });
      } catch (error) {
        onError(error);
      }
      return function () {
        var _signIn$off, _signIn$remove;
        (_signIn$off = signIn.off) === null || _signIn$off === void 0 ? void 0 : _signIn$off.call(signIn);
        (_signIn$remove = signIn.remove) === null || _signIn$remove === void 0 ? void 0 : _signIn$remove.call(signIn);
      };
    }
  }, [signIn]);

  // no config for us to disable username, so manually doing it
  // Also adds placeholder text for password
  var modifyInputFields = function modifyInputFields() {
    var authContainer = document.getElementsByClassName("auth-container");
    if (authContainer.length > 0) {
      var usernameInput = document.getElementById("okta-signin-username");
      if (usernameInput && disableUsernameInput) {
        usernameInput.disabled = true;
      }
    }
  };
  var success = function success(res) {
    if (res.status === "SUCCESS") {
      var _idToken$claims;
      var _window$mlbOkta = window.mlbOkta,
        setAccessTokeninCookie = _window$mlbOkta.setAccessTokeninCookie,
        setMaiCookie = _window$mlbOkta.setMaiCookie,
        setOktaIdCookie = _window$mlbOkta.setOktaIdCookie,
        setTokens = _window$mlbOkta.setTokens;
      var tokens = res.tokens;
      var idToken = tokens.idToken;
      setTokens(tokens);
      var oktaId = idToken === null || idToken === void 0 ? void 0 : (_idToken$claims = idToken.claims) === null || _idToken$claims === void 0 ? void 0 : _idToken$claims.sub;
      if (window.trackAsync && loginSuccessProps) {
        window.trackAsync(_objectSpread(_objectSpread({}, loginSuccessProps), {}, {
          prop22: oktaId
        }));
      }
      setMaiCookie();
      setOktaIdCookie();
      setAccessTokeninCookie();
      setIsLoggedIn(true);
      onSuccess(tokens);
    } else {
      onFailure();
    }
  };
  if (oktaLibraryError) {
    return null;
  } else if (!oktaLibraryError && !isLoggedIn) {
    return /*#__PURE__*/React.createElement(LoginSection, _extends({
      style: {
        backgroundColor: backgroundColor,
        width: containerWidth
      },
      className: "login__section"
    }, containerProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 241,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement(LoginContainer, {
      className: "login__container",
      helpLinks: combinedHelpLinks,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 246,
        columnNumber: 9
      }
    }, widgetRendered && /*#__PURE__*/React.createElement(React.Fragment, null, header && /*#__PURE__*/React.createElement(LoginHeader, {
      className: "login__header",
      dangerouslySetInnerHTML: {
        __html: header
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 253,
        columnNumber: 17
      }
    }), subHeaderMessage && /*#__PURE__*/React.createElement(LoginSubHeader, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 259,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "login-subheader",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 260,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: subHeaderMessage
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 261,
        columnNumber: 21
      }
    })))), "* ", requiredCopy, /*#__PURE__*/React.createElement("div", {
      id: "OKTASignin",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 270,
        columnNumber: 11
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(LoginSection, _extends({
      style: {
        backgroundColor: backgroundColor
      },
      success: true
    }, containerProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 276,
        columnNumber: 7
      }
    }), successHeader && /*#__PURE__*/React.createElement(LoginHeader, {
      dangerouslySetInnerHTML: {
        __html: successHeader
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 278,
        columnNumber: 11
      }
    }), successSubHeader && /*#__PURE__*/React.createElement(LoginSubHeader, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 281,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "login-subheader",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 282,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: successSubHeader
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 283,
        columnNumber: 15
      }
    }))));
  }
};
Login.propTypes = {
  containerProps: PropTypes.object,
  containerWidth: PropTypes.string,
  backgroundColor: PropTypes.string,
  email: PropTypes.string,
  disableUsernameInput: PropTypes.bool,
  locale: PropTypes.string,
  setAccountType: PropTypes.func,
  copyConfig: PropTypes.shape({
    widgetHeader: PropTypes.string,
    header: PropTypes.string,
    subHeaderMessage: PropTypes.string,
    usernamePlaceholder: PropTypes.string,
    passwordPlaceholder: PropTypes.string,
    submitButton: PropTypes.string,
    helpLink: PropTypes.string,
    registerLabel: PropTypes.string,
    registerLink: PropTypes.string,
    errorMessage: PropTypes.string,
    successHeader: PropTypes.string,
    successSubHeader: PropTypes.string
  }),
  features: PropTypes.shape({
    registration: PropTypes.bool,
    rememberMe: PropTypes.bool
  }),
  helpLinks: PropTypes.shape({
    help: PropTypes.string,
    forgotPassword: PropTypes.string,
    custom: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string,
      target: PropTypes.string
    }))
  }),
  tracking: PropTypes.shape({
    loginSuccessProps: PropTypes.object,
    loginFailureProps: PropTypes.object,
    loginSubmitProps: PropTypes.object
  }),
  onSuccess: PropTypes.func,
  onFailure: PropTypes.func,
  onError: PropTypes.func
};
export default Login;